import React, { useContext, useEffect } from 'react';
import WordCard from '../components/WordCard';
import { useLocation } from 'react-router-dom';
import { themes } from '../utils/themes';
import { UserContext } from '../store/useStore';

export default function Theme() {
  const { state } = useLocation();
  const { getWordsFromTheme, wordsTheme } = useContext(UserContext);

  useEffect(() => {
    console.log(state.themeName)
    getWordsFromTheme(state.themeName ? state.themeName : themes[0].themeName);
  }, [state]);

  useEffect(() => {
    console.log(wordsTheme)
  }, [wordsTheme]);

  return (
    <div className='min-h-screen bg-gradient-to-br from-purple-50 to-white pb-16'>
      <div className="p-6 max-w-7xl mx-auto ">
        <div className='flex flex-row'>
        <h1 className="text-3xl font-bold text-gray-900 mb-8">{themes[state.index ? state.index : 0].icon} Learning Theme {state?.themeName ? state.themeName : themes[0].themeName}</h1>
        </div>

        <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">Words</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {wordsTheme && themes[state.index ? state.index : 0].words.map((word) => (
                    <WordCard
                        key={word}
                        word={word}
                        fromTheme={true}
                        themeName={themes[state.index ? state.index : 0].themeName}
                        lastPractice={wordsTheme.find(wordTheme => wordTheme.word === word)?.lastPractice}
                        progress={wordsTheme.find(wordTheme => wordTheme.word === word)?.progress}
                    />
                ))}
            </div>
        </div>
      </div>
    </div>
  );
}

interface StatCardProps {
  icon: React.ElementType;
  title: string;
  value: string;
  color: string;
}

function StatCard({ icon: Icon, title, value, color }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 w-fit">
      <div className="flex items-center space-x-4">
        <div className={`${color} bg-opacity-10 p-3 rounded-lg`}>
          <Icon className={`w-6 h-6 ${color}`} />
        </div>
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <p className="text-xl font-semibold text-gray-900">{value}</p>
        </div>
      </div>
    </div>
  );
}